import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"

export interface PlickResponse {
	id: number
	transactionId: string | undefined
	senderId: string | undefined
	senderFirstname: string | undefined
	senderLastname: string | undefined
	senderIsCompany: boolean
	senderCompany: string | undefined
	senderDevice: string | undefined
	senderAccount: string | undefined
	senderLanguagePreferences: string | undefined
	senderExtraInfo: string | undefined
	receiverName: string | undefined
	receiverDevice: string | undefined
	receiverIban: string | undefined
	receiverIbanFromBank: boolean
	idBank: string | undefined
	activationDate: string | undefined
	amount: number
	amountString: string | undefined
	causal: string | undefined
	notes: string | undefined
	pin: string | undefined
	pinType: string | undefined
	idLogo: string | undefined
	correctPlick: boolean
	status: string | undefined
	plickType: string | undefined
	receiverType: string | undefined
	fileDataDto: null
	fileId: string | undefined
	validationErrors: string | undefined
	validationErrorsList: any
	bankCro: null
	bankExecutionDate: null
	currencyDate: null
	transferStatus: null
	plickIdFromPortal: null
	fileVersion: 1
	checkIbanCode: null
	checkIban: boolean
	checkIbanLastStatus: null
	voucher: boolean
}

interface PlickPayload {
	bankId: string | undefined
	fileId: string | undefined
	plickId: string | undefined
}

interface IPatchPayload {
	plickData: {
		transactionId?: string
		senderCompany?: string
		senderDevice?: string
		senderLanguagePreferences?: string
		senderExtraInfo?: string
		receiverName?: string
		receiverDevice?: string
		receiverIban?: string
		receiverIbanFromBank?: boolean
		activationDate?: string
		amount?: string
		causal?: string
		pin?: string
		pinType?: string
		checkIbanCode?: string
	}
	idBank: string
	idPlick: string
}

export interface PlickDetailState {
	loading: boolean
	error: undefined // TODO
	data: PlickResponse | undefined
}

export const getPlickDetail = createAsyncThunk<
	PlickResponse,
	PlickPayload,
	{ rejectValue: string }
>(
	"plick/detail",
	async ({ bankId, fileId, plickId }: PlickPayload, { rejectWithValue }) => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}
			const response: AxiosResponse<PlickResponse> = await axios.get(
				`${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/${bankId}/${fileId}/plick/${plickId}`,
				config
			)
			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<string>

			return rejectWithValue(axiosError?.response?.data ?? "generic")
		}
	}
)

export const updatePlick = createAsyncThunk<
	PlickResponse,
	IPatchPayload,
	{ rejectValue: unknown }
>(
	"plick/patch",
	async (
		{ plickData, idBank, idPlick }: IPatchPayload,
		{ rejectWithValue }
	) => {
		try {
			const headerConfig: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}
			const response: AxiosResponse<PlickResponse> = await axios.patch(
				`${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/${idBank}/update/${idPlick}`,
				plickData,
				headerConfig
			)
			return response.data
		} catch (error) {
			const axiosError = error as AxiosError
			return rejectWithValue(axiosError.response?.data ?? "generic")
		}
	}
)
